import { useEffect, useState } from 'react';
import { apiFetch } from '../../hooks/useApi.js';

/**
 * "Already in stock?" — while someone types a new stock item's name, the
 * items that look like the same thing (Joe, 3 Nov 2026), so it isn't added
 * twice. onUse(item) lets them pick the existing one instead.
 */
export default function SimilarStockItems({ name, onUse, useLabel = 'Use this' }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const q = String(name || '').trim();
    if (q.length < 3) { setItems([]); return undefined; }
    let live = true;
    const t = setTimeout(async () => {
      try { const r = await apiFetch(`/stock/similar?name=${encodeURIComponent(q)}`); if (live) setItems(r.items || []); } catch { if (live) setItems([]); }
    }, 300);
    return () => { live = false; clearTimeout(t); };
  }, [name]);
  if (!items.length) return null;
  const exact = items.some((i) => i.exact);
  return (
    <div style={{ fontSize: 12.5, background: exact ? '#fee2e2' : '#fef3c7', color: exact ? '#991b1b' : '#92400e', borderRadius: 'var(--radius)', padding: '8px 10px', display: 'flex', flexDirection: 'column', gap: 4 }}>
      <strong>{exact ? 'Already in stock:' : 'Is it one of these?'}</strong>
      {items.map((it) => (
        <div key={it.id} style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
          <span style={{ flex: 1 }}>{it.name} <span style={{ opacity: 0.75 }}>{it.sku} · {it.unit}{it.is_active ? '' : ' · inactive'}</span></span>
          {onUse && it.is_active && <button type="button" onClick={() => onUse(it)} style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer', fontSize: 12.5, fontWeight: 600 }}>{useLabel}</button>}
        </div>
      ))}
    </div>
  );
}
